<template>
    <el-container class="bodycontainer">
        <!-- 封装侧栏组件 -->
         <el-container class="bodymain">
            <Aside :isCollapse="isCollapse" :menu="menu"></Aside>
            <el-container :class="{'is-collapsea':isCollapse}">

                <el-header height="82px" direction="vertical">
                    <!-- 头部组件 -->
                    <Header :isCollapse="isCollapse" @toggle="toggle" :userInfo="userInfo" class="headertop"></Header>                    
                    <Navbar></Navbar>
                </el-header>

                <el-main id="el-main" style="padding:20px;">                    
                    <transition name="fade" mode="out-in">
                        <router-view></router-view>
                    </transition>
                </el-main>
<!--                 <el-footer class="footer">Footer</el-footer> -->
            </el-container>
         </el-container>
    </el-container>
</template>

<script>
    import Aside from '@/components/Aside';
    import Header from '@/components/Header';
    import Navbar from '@/components/Navbar';
    export default {
        name: "layout",
        components: {
            Aside,
            Header,
            Navbar
        },
        data() {
            return {
                isCollapse: false,
                userInfo: [],
                menu: [],
            };
        },
        computed: {

        },
        methods: {
            toggle: function() {
                this.isCollapse = !this.isCollapse;
            }
        },
        //初始化数据钩子
        created: function(){
            let userInfo = this.$getUserInfo();
            this.userInfo = userInfo;
            this.menu = userInfo.auth;
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .bodycontainer {
        height: 100%;
        width: 100%
    }
    .bodymain{
        width: 100%;
        height: 100%;
    }
    
    .el-header {       
        padding: 0
    }
    .el-header .headertop{
        background-color: #3f515e;
    }
    .footer{
        height: 30px !important;
        text-align: center;
        color:#fff;
        font-size: 12px;
        line-height: 30px;
        background: #425265
    }
    .fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    }
    .el-main{position: relative;}    
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue